/** The valid cognito attributes stored on aKin cognito user records */
export enum CognitoUserAttributes {
  EMAIL_VERIFIED = 'custom:email_verified',
  EMAIL_VERIFICATION_CODE = 'custom:email_verify_code',
  EMAIL_VERIFICATION_EXPIRY = 'custom:email_verify_expiry',
  HUBSPOT_ID = 'custom:hubspot_id',
  EMAIL = 'email',
  SUB = 'sub',
}

/** An enum of the groups currently defined in cognito */
export enum CognitoUserGroup {
  ADMIN = 'admins',
  CONTENT_WRITER = 'contentWriters',
  DEVELOPER = 'developer',
  INTERNAL = 'internalAkin',
  ROBOT_USERS = 'robotUsers',
  SUPPORT_WORKER = 'supportWorkers',
}
